import React, { useEffect } from "react";
import { connect } from "react-redux";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { isLoginAuth } from "utils/common";
import { lStorage } from "utils/storage";
const Login = () => {
  const history = useHistory();
  useEffect(() => {
    if (!isLoginAuth()) {
      import("hfnauth/main")?.then(() => {
        document.querySelector("hfn-auth")?.triggerAuth();
      });
    }
    if (isLoginAuth()) {
      const { role } = lStorage.get("authInfo") || {};
      if (role) {
        history.push("/template/listing");
      } else {
        history.push("/unauthorized");
      }
    }
  }, []);
  return (
    <>
      <div />
    </>
  );
};

// export default Login
const mapStateToProps = (state) => ({
  ld: state.loginDetails,
});

export default connect(mapStateToProps)(Login);
